export const Debug: boolean = false;